import React, { useEffect } from 'react';

const Login: React.FC = () => {
  useEffect(() => {
    window.location.href = 'https://shopline-frontend.pages.dev/login';
  }, []);
  return null;
};

export default Login;
